import { useCallback, useEffect, useRef } from 'react'

export default function useDebounce(fn, delay) {
  const fnRef = useRef(fn)
  fnRef.current = fn
  const timerRef = useRef(null)
  useEffect(() => () => clearTimeout(timerRef.current), [])
  return useCallback(
    (...args) => {
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => fnRef.current(...args), delay)
    },
    [delay]
  )
}
